import Prismic from 'prismic-javascript'

const client = Prismic.client(
  'https://chemistry-on-self-oganization.cdn.prismic.io/api/v2'
)

export default client
